/* OJ 2026-10-05: replaces the old inline script in snippets/product-variant-picker.liquid, which
   hard-coded each pack by position and gave the 3-pack a struck $12.97 and no "SAVE $5.00".
   Sets the struck price and both SAVE badges from the theme's own variant data whenever the
   widget renders or the pack changes. Writes only when a value is wrong.
   2026-10-29: Subscribe strikes the same "was" price as One Time Purchase (the pack's compare-at,
   e.g. 3-pack $38.97 -> $30.97, SAVE $8.00), as the store's original script did.
   2026-11-01: SAVE badge on Subscribe only; One Time Purchase keeps its struck price, no badge. */
(function () {
  var PID = window.__ojPid;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function product() { return window._themeProducts && window._themeProducts[PID]; }
  function variant() {
    var p = product(); if (!p) return null;
    var inp = document.querySelector('.m-product-form--main [name="id"]');
    var id = (inp && inp.value) || new URLSearchParams(location.search).get('variant');
    for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i];
    return null;
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setClass(el, c, on) { if (el && el.classList.contains(c) !== on) el.classList.toggle(c, on); }
  /* assets/custom.css shows the badges inside these two wrappers only WITH .hide (inverted) */
  function showBadge(el, on) {
    if (!el) return;
    var inverted = !!el.closest('.appstle_one_time_details_wrapper, .payAsYouGoPlansDropdownWrapper');
    setClass(el, 'hide', inverted ? on : !on);
  }
  function fix() {
    var w = document.getElementById('appstle_subscription_widget0'), v = variant();
    if (!w || !v) return;
    var sp = (v.selling_plan_allocations || [])[0];
    if (sp) {
      var subCmp = v.compare_at_price > v.price ? v.compare_at_price : v.price;
      var sc = w.querySelector('span.appstle_subscription_compare_amount');
      if (subCmp > sp.price) { setText(sc, money(subCmp)); setClass(sc, 'active', true); }
      else setClass(sc, 'active', false);
      var sb = w.querySelector('.appstle-text-and-badge-wrapper .appstle-save-badge');
      if (subCmp > sp.price) setText(sb, 'SAVE ' + money(subCmp - sp.price));
      showBadge(sb, subCmp > sp.price);
    }
    showBadge(w.querySelector('.appstle_one_time_text .appstle-save-badge'), false);
  }
  var raf = 0;
  function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; fix(); }); }
  var watched = null;
  var mo = new MutationObserver(function () {
    var w = document.getElementById('appstle_subscription_widget0');
    if (w && w !== watched) { watched = w; mo.observe(w, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] }); }
    schedule();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function () { setTimeout(fix, 60); setTimeout(fix, 400); }, true);
  window.addEventListener('load', function () { fix(); setTimeout(fix, 800); setTimeout(fix, 2500); });
})();
